import {
  MONITOR_LOAD,
  MONITOR_LOAD_SUCCESS,
  MONITOR_ERROR,
  MONITOR_CLEAN,
  EXPORT_ORDERS,
  EXPORT_ORDERS_SUCCESS
} from "./actionTypes"

export const monitorError = error => {
  return {
    type: MONITOR_ERROR,
    payload: error,
  }
}
export const initLoadOrders = (filter) => {
  return {
    type: MONITOR_LOAD,
    payload: filter,
  }
}

export const loadOrders = orders => {
  return {
    type: MONITOR_LOAD_SUCCESS,
    payload: orders,
  }
}

export const cleanOrders = () => {
  return {
    type: MONITOR_CLEAN,
    payload: {},
  }
}
export const initExport = (filter) => {
  return {
    type: EXPORT_ORDERS,
    payload: filter,
  }
}

export const exportSuccess = orders => {
  return {
    type: EXPORT_ORDERS_SUCCESS,
    payload: orders,
  }
}
